// extracted by mini-css-extract-plugin
module.exports =  {"root":"LhWiBcyofw4Uai0ZucQc"};